// services/FindYourFloorsService.js
import API from "../../../app/api";

export const getFindYourFloors = async () => {
  try {
    const res = await API.get("banners/floor-matcher");

    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch 'Find Your Floor'");
    }

    // Return the banner array
    return res.data?.data || [];
  } catch (error) {
    console.error("FindYourFloors error:", error);
    return []; // fallback to empty array
  }
};